import { Controller } from "@hotwired/stimulus";

// Disables a refresh button briefly after it's clicked so mashing "Refresh All" doesn't fire a burst
// of forced Snowflake re-runs (per-chart serialized, but not deduped against each other).
export default class extends Controller {
  static targets = ["button"];
  static values = { seconds: { type: Number, default: 10 } };

  connect() {
    this.onSubmit = () => this.disableTemporarily();
    this.element.addEventListener("turbo:submit-start", this.onSubmit);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.onSubmit);
    clearTimeout(this.timer);
  }

  disableTemporarily() {
    if (!this.hasButtonTarget || this.buttonTarget.disabled) return;

    this.buttonTarget.disabled = true;
    this.timer = setTimeout(() => {
      this.buttonTarget.disabled = false;
    }, this.secondsValue * 1000);
  }
}
